// inview
$(function() {
	$('#C-rehello .C-logo-top,#C-rehello h2,#C-rehello .C-block1 p,C-rehello .C-block1 p,#C-rehello .C-block3 p,#C-rehello .C-block5 p,#C-rehello .C-block5 img').on('inview', function(event, isInView, visiblePartX, visiblePartY) {
		if(isInView){
			$(this).stop().addClass('animated fadeIn delay01');
		}
		else{
			// $(this).stop().removeClass('animated fadeIn');
		}
	});

});

		$(window).on('scroll', function(){

			var scrollTop = $(window).scrollTop();
			var bgPosition = scrollTop / 15;

			if(bgPosition){
				$('.C-block4').css('background-position', 'center top -'+ bgPosition + 'px');
			}
		});

$(window).on('scroll', function(){

  var scrollTop = $(window).scrollTop();
  var bgPosition = scrollTop / 15;

  if(bgPosition){
    $('.C-block2').css('background-position', 'center top -'+ bgPosition + 'px');
  }
});
